<div class="csslider infinity" id="slider1">
  <div class="d-flex justify-content-center align-items-center m-auto text-center">
    <h1 class="header-h1 "><span style="font-size: 16px; font-weight: normal; line-height: 30px;">Upto</span>50% off on
      everything</h1>
  </div>
</div> 
<div id="carouselExampleIndicators" class="carousel slide " data-ride="carousel">
  <ol class="carousel-indicators">
    <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
    <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
    <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
    <li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
  </ol>
  <div class="carousel-inner">
    <div class="carousel-item active position-relative d-flex justify-content-center align-items-center">
      <img src="https://firebasestorage.googleapis.com/v0/b/zeroarmario.appspot.com/o/thai-an-fPny13VTWks-unsplash%402x%201.png?alt=media&token=ca50877d-5312-4114-ae96-6856621d1282" class="d-block w-100 " alt="...">
      <h1 class="header-h1"><span style="font-size: 22px; font-weight: normal; line-height: 30px;">Upto</span>50% off on
        everything</h1>
    </div>
    <div class="carousel-item position-relative d-flex justify-content-center align-items-center">
      <img src="https://firebasestorage.googleapis.com/v0/b/zeroarmario.appspot.com/o/thai-an-fPny13VTWks-unsplash%402x%201.png?alt=media&token=ca50877d-5312-4114-ae96-6856621d1282" class="d-block w-100" alt="...">
      <h1 class="header-h1 "><span style="font-size: 22px; font-weight: normal; line-height: 30px;">Upto</span>50% off on
      everything</h1>
    </div>
    <div class="carousel-item position-relative d-flex justify-content-center align-items-center">
      <img src="https://firebasestorage.googleapis.com/v0/b/zeroarmario.appspot.com/o/thai-an-fPny13VTWks-unsplash%402x%201.png?alt=media&token=ca50877d-5312-4114-ae96-6856621d1282" class="d-block w-100" alt="...">
      <h1 class="header-h1 "><span style="font-size: 22px; font-weight: normal; line-height: 30px;">Upto</span>50% off on
      everything</h1>
    </div>
    <div class="carousel-item position-relative d-flex justify-content-center align-items-center">
      <img src="https://firebasestorage.googleapis.com/v0/b/zeroarmario.appspot.com/o/thai-an-fPny13VTWks-unsplash%402x%201.png?alt=media&token=ca50877d-5312-4114-ae96-6856621d1282" class="d-block w-100" alt="...">
      <h1 class="header-h1 "><span style="font-size: 22px; font-weight: normal; line-height: 30px;">Upto</span>50% off on
      everything</h1>
    </div>
  </div>

</div> 

<section class="explore-product">
  <div class="container">
    <h3>Explore Products</h3>
    <hr class="line">
    <div class="row" routerLink="productlists/Coupler wears/Coupler wears">
      <div class="col-6 col-lg-2 col-xs-6 col-sm-6" routerLink="productlists/Henley shirts/Henley shirts">
        <img src="../../assets/images/png/products/4.png" alt="" />
        <p><i>Henley shirts</i></p>
      </div>
      <div class="col-6 col-lg-2 col-xs-6 col-sm-6" routerLink="productlists/Plain wear/Plain wear">
        <img src="../../assets/images/png/products/3.png" alt="" />
        <p><i>Plain wear</i></p>
      </div>
      <div class="col-6 col-lg-2 col-xs-6 col-sm-6" routerLink="productlists/Sweat shirts/Sweat shirts">
        <img src="../../assets/images/png/products/5.png" alt="" />
        <p><i>Sweatshirts</i></p>
      </div>
      <div class="col-6 col-lg-2 col-xs-6 col-sm-6" routerLink="productlists/Couple wears/Couple wears">
        <img src="../../assets/images/png/products/1.png" alt="" />
        <p><i>Couple wears</i></p>
      </div>
      <div class="col-6 col-lg-2 col-xs-6 col-sm-6" routerLink="productlists/Hoddies/Hoddies">
        <img src="../../assets/images/png/products/6.png" alt="" />
        <p><i>Hoddies</i></p>
      </div>
      <div class="col-6 col-lg-2 col-xs-6 col-sm-6" routerLink="productlists/Covid 19/Covid 19">
        <img src="../../assets/images/png/products/2.png" alt=""/>
        <p><i>Covid 19</i></p>
      </div>
    </div>
  </div>
</section>


<section class="handpicked-categories">
  <div class="container">
    <h3>Handpicked categories</h3>
    <p style="text-align: center;">Explore our complete handmade products<br>featuring farhuman</p>
    <hr class="line">
    <div class="row handpicked-img" style="margin-top: 50px;">
      <div class="col-sm-12 col-md-6 col-lg-3" routerLink="productlists/Women/Women" style="margin-bottom: 30px;">
        <img src="../../assets/images/png/categories/women.png" alt="" />
        <h4>Womens</h4>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-3" routerLink="productlists/Men/Men" style="margin-bottom: 30px;">
        <img src="../../assets/images/png/categories/men.png" alt="" />
        <h4>Men</h4>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-3" routerLink="productlists/Children/Children" style="margin-bottom: 30px;">
        <img src="../../assets/images/png/categories/children.png" alt="" />
        <h4>Children</h4>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-3" routerLink="productlists/Home/Home" style="margin-bottom: 30px;">
        <img src="../../assets/images/png/categories/stationary.png" alt="" />
        <h4>Home</h4>
      </div>
    </div>
  </div>
</section>
<section class="shop-by-design">
  <div class="container pt-3 pr-5 pl-5">
    <h3>Shop by Design</h3>
    <p style="text-align: center;">Explore our designs from different genre<br>featuring Zeroarmario</p>
    <hr class="line">
    <div class="row pt-5" >
      <div class="item col-md-6 col-sm-12 ">
        <img  src="../../assets/images/item1.png" alt="" />
        <h4 class="left">Dream of 2044</h4>
      </div>
      <div class="item col-md-6 col-sm-12">
        <img src="../../assets/images/item2.png" alt=""/>
        <h4 class="right">- Love to boo</h4>
      </div>
    </div>
    <div class="row" >
      <div class="item col-md-6 col-sm-12">
        <img src="../../assets/images/item3.png" alt=""/>
        <h4 class="left">Minimalism</h4>
      </div>
      <div class="item col-md-6 col-sm-12">
        <img src="../../assets/images/item4.png" alt=""/>
        <h4 class="right">View all</h4>
      </div>
    </div>
  </div>
</section>
<section class="pack pl-5 pr-5">
  <div class="container">
    <h3>Recharge your Saving</h3>
    <p style="text-align: center;">Shop all your favourite clothes with much reasonable price</p>
    <hr class="line">
    <div class="row" >
      <div class="col-lg-4 col-sm-12 mb-4" style="align-self:flex-end; margin-bottom: 10px;">
        <img src="../../assets/images/png/pack/2.png" alt="" />
        <button class="btn-1">30% Sale</button>
      </div>
      <div class="col-lg-4 col-sm-12 mb-4" style="margin-bottom: 10px;">
        <img src="../../assets/images/png/pack/1.png" alt="" />
        <div class="pack-title-1">
          <h4 style="text-align: center;">20% Sale<br>on Student ID</h4>
          </div>
        <button class="btn-2">Shop Now</button>
      </div>
      <div class="col-lg-4 col-sm-12 mb-4" style="align-self: flex-end; margin-bottom: 10px;">
        <img src="../../assets/images/png/pack/3.png" alt="" />
        <div class="pack-title-2" style="font-size: 22px;text-align: center;font-size: bold;">Deal of the season</div>
      </div>
    </div>
  </div>
</section>
<section class="bestproduct pl-3 pr-3 pt-0">
  <div class="container">
    <h3>Best product selling for us</h3>
    <hr class="line">
  <br><br>
  <div class="row">
    <div class="col-sm-6 col-6 col-md-6 col-lg-3" id="product"  *ngFor="let product of products">
      <app-productitem [data]="product"
      ></app-productitem>
    </div>
  </div>
  </div>
  <div class="container" style="text-align: center;
width: 300px;
height: 200px;
padding-top: 10px;
}
#btn{
font-size: 25px;
">
    <button  class="btn" routerLink="productlists/NULL/All Products" style="align-items: center; align-content: top;">
     <a style="font-size: 12px">VIEW ALL PRODUCTS</a>  <span style="margin-left: 12px;" class="iconify" data-icon="bi:arrow-right" data-inline="false"></span>
    </button>
  </div>
</section>